import { render, staticRenderFns } from "./PromoPageUpsellBanner.vue?vue&type=template&id=2495aae6&scoped=true&"
import script from "./PromoPageUpsellBanner.vue?vue&type=script&lang=ts&"
export * from "./PromoPageUpsellBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PromoPageUpsellBanner.vue?vue&type=style&index=0&id=2495aae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495aae6",
  null
  
)

export default component.exports